import { motion } from "framer-motion";
import { Apple } from "lucide-react";
import { APP_STORE_URL } from "@/lib/site";

export const AppStoreButton = ({
  testid = "app-store-download-btn",
  dark = true,
  className = "",
}) => (
  <motion.a
    href={APP_STORE_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    whileHover={{ scale: 1.04, y: -2 }}
    whileTap={{ scale: 0.97 }}
    transition={{ type: "spring", stiffness: 400, damping: 18 }}
    className={`inline-flex items-center gap-3 rounded-full px-7 py-3.5 font-bold shadow-[0_18px_40px_-12px_rgba(26,26,26,0.45)] ${
      dark ? "bg-ink text-sand" : "bg-cream text-terracotta-dark"
    } ${className}`}
  >
    <Apple size={22} strokeWidth={2.4} />
    <span className="flex flex-col items-start leading-none">
      <span className="text-[10px] font-semibold uppercase tracking-widest opacity-70">
        Download on the
      </span>
      <span className="text-base font-extrabold">App Store</span>
    </span>
  </motion.a>
);
